import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../components/layouts/dashboardLayout";
import { BASE_URL } from "../../config/endPoint";
import { httpDelete, httpGet } from "../../utils/api";

function Products() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // ✅ FILTER STATES
  const [jewelryType, setJewelryType] = useState("");
  const [metalType, setMetalType] = useState("");
  const [stoneType, setStoneType] = useState("");
  const [diamond, setDiamond] = useState("");
  const [color, setColor] = useState("");
  const [material, setMaterial] = useState("");
  const [jewelryList, setJewelryList] = useState([]);
  const [metalList, setMetalList] = useState([]);
  const [stoneList, setStoneList] = useState([]);
  const [diamondList, setDiamondList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [colorList, setColorList] = useState([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setId(id);
    setShow(true);
  };

  // ✅ GET PRODUCTS
  const getProducts = async (
    pageNo = page,
    pageSize = limit,
    filters = {}
  ) => {
    setIsLoading(true);
    try {
      const query = new URLSearchParams({
        page: pageNo,
        limit: pageSize,
        search,
        jewelryType,
        metalType,
        stoneType,
        diamond,
        color,
        material,
        ...filters,
      });

      const res = await httpGet(`${BASE_URL}/product/list?${query}`);

      if (res?.data?.status) {
        console.log("product",res.data.response)
        setData(res.data.response || []);
        setTotalRows(res.data.total || 0);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const getJewelryTypes = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/jewelry/list`);
      if (res?.data?.status) {
        setJewelryList(res.data.response || []);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getMetalTypes = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/metal/list`);

      if (res?.data?.status) {
        setMetalList(res.data.response || []); // ✅ NOT setData
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getStoneTypes = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/stone/list`);

      if (res?.data?.status) {
        setStoneList(res.data.response || []); // ✅ NOT setData
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getDiamondTypes = async () => {
    try {
      const response = await httpGet(`${BASE_URL}/diamonds`);

      if (response?.data?.status) {
        setDiamondList(response.data.data || []); // ✅ correct
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getMaterialTypes = async (value = "") => {
  try {
    let typeparams = value !== "" ? value : "";

    const response = await httpGet(
      `${BASE_URL}/materials?type=${typeparams}`
    );

    if (response?.data?.status) {
      setMaterialList(response?.data.data || []); // ✅ NOT setData
    }
    } catch (error) {
      console.error(error);
    }
  };
  const getColorTypes = async () => {
    try {
      const response = await httpGet(`${BASE_URL}/colors`);

      if (response?.data?.status) {
        setColorList(response?.data.data || []); // ✅ NOT setData
      }
    } catch (error) {
      console.error(error);
    }
  };




  useEffect(() => {
    getJewelryTypes();
    getMetalTypes();
    getStoneTypes();
    getDiamondTypes();
    getMaterialTypes();
    getColorTypes();
  }, []);
  useEffect(() => {
    getProducts(page, limit);
  }, [page, limit, search, jewelryType, metalType, stoneType, diamond, color, material]);

  // ✅ TABLE COLUMNS

  const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
  const columns = [
    {
      name: <b>Product Name</b>,
      selector: (row) => row?.productName,
      sortable: true,
    },
    {
      name: <b>Product Description</b>,
      selector: (row) =>
        row?.description ? row.description.slice(0, 100) : "",
      sortable: true,
    },
     {
    name: <b>Product Category</b>,
    cell: (row) => (
      <span className="badge bg-primary" style={{ fontSize: "12px" }} >
        {row?.cateId?.name || "N/A"}
      </span>
    ),
    sortable: true,
  },
    {
      name: <b>Product Price</b>,
      selector: (row) => row?.price,
      sortable: true,
    },
     {
    name: <b>Created Date</b>,
    selector: (row) => formatDate(row?.createdAt),
    sortable: true,
  },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => navigate(`/edit-product/${row?._id}`)}
            style={{ border: "none", background: "transparent" }}
          >
            <i className="fa-solid fa-pen" style={{ color: "blue" }}></i>
          </button>

          <button
            onClick={() => handleShow(row?._id)}
            style={{ border: "none", background: "transparent" }}
          >
            <i className="fas fa-trash" style={{ color: "#f00" }}></i>
          </button>
        </div>
      ),
    },
  ];

  // ✅ DELETE
  const deleteProduct = async () => {
    setIsLoading(true);
    try {
      const res = await httpDelete(`${BASE_URL}/product/${id}`);
      if (res?.data?.status) {
        toast.success(res.data.message);
        getProducts();
        setShow(false);
      }
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  // ✅ FILTER LOGIC (VERY IMPORTANT)
  // const filteredItems = data.filter((item) => {
  //   return (
  //     (search === "" ||
  //       item?.productName
  //         ?.toLowerCase()
  //         .includes(search.toLowerCase())) &&

  //     (jewelryType === "" || item?.jewelryType === jewelryType) &&
  //     (metalType === "" || item?.metalType === metalType) &&
  //     (stoneType === "" || item?.stoneType === stoneType) &&
  //     (diamond === "" || item?.diamond === diamond) &&
  //     (color === "" || item?.color === color) &&
  //     (material === "" || item?.material === material)
  //   );
  // });

  const actions = (
    <Button className="add-btn" onClick={() => navigate("/add-product")}>
      Add Product
    </Button>
  );

  return (
    <DashboardLayout>
      <div className="table-outer">
        <DataTable
          title="Products"
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={limit}
          onChangePage={(page) => {
            setPage(page);
            getProducts(page, limit);
          }}
          onChangeRowsPerPage={(newLimit, page) => {
            setLimit(newLimit);
            getProducts(page, newLimit);
          }}
          fixedHeader
          actions={actions}
          progressPending={isLoading}
          highlightOnHover
          selectableRowsHighlight
          subHeader
          subHeaderComponent={
            <div style={{ width: "100%" }}>
              {/* ✅ FILTER BAR */}
              <Row className="mb-2">
                <Col>
                  <Form.Control
                    placeholder="Search here"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </Col>

                {/* <Col>
                 <Form.Select
                    value={jewelryType}
                    onChange={(e) => setJewelryType(e.target.value)}
                  >
                    <option value="">Jewellery Type</option>

                    {jewelryList?.map((item) => (
                      <option key={item._id} value={item.jewelleryName}>
                        {item.jewelleryName}
                      </option>
                    ))}
                  </Form.Select>

                </Col>

                <Col>
                 <Form.Select
                      value={metalType}
                      onChange={(e) => setMetalType(e.target.value)}
                    >
                      <option value="">Metal Type</option>

                      {metalList?.map((item) => (
                        <option key={item._id} value={item.metalsName}>
                          {item.metalsName}
                        </option>
                      ))}
                    </Form.Select>
                </Col>

                <Col>
                  <Form.Select
                    value={stoneType}
                    onChange={(e) => setStoneType(e.target.value)}
                  >
                    <option value="">Stone Type</option>

                    {stoneList?.map((item) => (
                      <option key={item._id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>

                </Col> */}
              </Row>

              {/* <Row>
                <Col>
                  <Form.Select
                    value={diamond}
                    onChange={(e) => setDiamond(e.target.value)}
                  >
                    <option value="">Diamond</option>

                    {diamondList?.map((item) => (
                      <option key={item._id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>

                </Col>

                <Col>
                  <Form.Select
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                  >
                    <option value="">Color</option>

                    {colorList?.map((item) => (
                      <option key={item._id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>

                </Col>

                <Col>
                  <Form.Select
                    value={material}
                    onChange={(e) => setMaterial(e.target.value)}
                  >
                    <option value="">Material</option>

                    {materialList?.map((item) => (
                      <option key={item._id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>

                </Col>
              </Row> */}
            </div>
          }
        />

        {/* DELETE MODAL */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure, you want to delete this record?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No
            </Button>
            <Button variant="primary" onClick={deleteProduct}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </DashboardLayout>
  );
}

export default Products;
